'use strict';

const StorageAdapter = require('./StorageAdapter');

/**
 * In-memory storage adapter for Node.js or React Native.
 * @class
 * @extends StorageAdapter
 * @memberof AthomCloudAPI
 */
class StorageAdapterMemory extends StorageAdapter {

  constructor() {
    super();

    // We use Stringify/Parse to prevent direct manipulation
    this.__store = '{}';
  }

  /**
   * @returns {Promise<object>}
   */
  async get() {
    return JSON.parse(this.__store);
  }

  /**
   * @param {object} value
   * @returns {Promise<void>}
   */
  async set(value) {
    this.__store = JSON.stringify(value);
  }

}

module.exports = StorageAdapterMemory;
